// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":host{display:flex;flex:0 0 auto;z-index:3}:host .mat-toolbar{background:inherit;color:inherit;box-shadow:0px -1px 1px -1px rgba(0,0,0,.2),0px 0px 1px 0px rgba(0,0,0,.14),0px -1px 3px 0px rgba(0,0,0,.12)}:host.above{position:relative;z-index:99}", ""]);
// Exports
module.exports = exports;


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();